<div class="separator-line"></div>

<section class="section-next-festival">
  <div class="content-wrapper">
    <h2 class="titre-principal">{{ titrePrincipal }}</h2>
    <p class="sous-titre">{{ sousTitre }}</p>

    <a href="https://www.bylesjeuxdustan.fr/" target="_blank" class="btn-savoir-plus">
      En savoir plus
    </a>
  </div>
</section>